import { render, staticRenderFns } from "./forwardingReport.vue?vue&type=template&id=756db669&scoped=true&"
import script from "./forwardingReport.vue?vue&type=script&lang=js&"
export * from "./forwardingReport.vue?vue&type=script&lang=js&"
import style0 from "./forwardingReport.vue?vue&type=style&index=0&id=756db669&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756db669",
  null
  
)

export default component.exports